import React, { useState } from 'react'
import { useFormik } from 'formik'
import { uploadRes, uploadTodo } from '../../LMS_Redux/LMS_Slices/Assets/UploadImage'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { AddExternalTrainingSchema } from './CourseManagementSchema'
import { addExternalTrainingRes, addExternalTrainingTodo } from '../../LMS_Redux/LMS_Slices/Course/AddExternalTraining'
import { Spinner } from 'react-bootstrap'

export default function AddExternalTraining() {

  const [spinner, setSpinner] = useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const initialValues = {
    ext_training: '',
    training_agency: '',
    program_details: '',
    training_date: '',
    duration: '',
    ceritificate: '',
    other: '',
  }

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
    initialValues: initialValues,
    validationSchema: AddExternalTrainingSchema,
    // enableReinitialize: true,

    onSubmit: (values, action) => {
      // console.log("new", values)
      setSpinner(true)
      dispatch(addExternalTrainingTodo(values)).then(() => add_res(action))
    },
  })

  const add_res = (action) => {
    if (addExternalTrainingRes && addExternalTrainingRes.success) {
      action.resetForm();
      toast.success(addExternalTrainingRes.message, { position: "bottom-right" })
      setTimeout(() => {
        navigate('/external_training_list')
      }, 1000);
      setSpinner(false)
    } else {
      toast.error(addExternalTrainingRes.message, { position: "bottom-right" })
      setSpinner(false)
    }
  }

  const uploads = (file, field) => {
    if (file) {
      dispatch(uploadTodo(file)).then(() => upload_res(field))
    }
  }

  const upload_res = (field) => {
    if (uploadRes && uploadRes.success) {
      if (field == 'certificate') {
        setFieldValue(`ceritificate`, uploadRes.data.path)
      } else {
        setFieldValue(`other`, uploadRes.data.path)
      }
      toast.success(uploadRes.message, { position: "bottom-right" })
    } else {
      toast.error(uploadRes.message, { position: "bottom-right" })
    }
  }

  return (
    <>
      <div className='container-fluid'>
        <div className='scnd-header'>
          <span className='icon1'>Learning Module Management / </span>
          <span className='icon2'>Add External Training</span>
        </div>

        <div className='wrapper-admin'>
          <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
            <div className="row">

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">External Training Title</label>
                  <input type="text" className="form_input form-control" placeholder="Course Title"
                    name='ext_training' value={values.ext_training || ''} onChange={handleChange} onBlur={handleBlur}
                  />
                  {errors.ext_training && touched.ext_training ? (<span className='text-danger form_label'>{errors.ext_training}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">Training Agency</label>
                  <input type="text" className="form_input form-control" placeholder="Course Title"
                    name='training_agency' value={values.training_agency || ''} onChange={handleChange} onBlur={handleBlur}
                  />
                  {errors.training_agency && touched.training_agency ? (<span className='text-danger form_label'>{errors.training_agency}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">Training Program Details</label>
                  <textarea className="form-control form_input" rows="1"
                    name='program_details' value={values.program_details || ''} onChange={handleChange} onBlur={handleBlur} placeholder='Training Description'
                  />
                  {errors.program_details && touched.program_details ? (<span className='text-danger form_label'>{errors.program_details}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="" className="form-label form_label">Training Date</label>
                  <input type="date" className="form-control form_input"
                    name='training_date' value={values.training_date} onChange={handleChange} onBlur={handleBlur}
                    max={new Date().toISOString().split('T')[0]}
                  />
                  {errors.training_date && touched.training_date ? (<span className='text-danger form_label'>{errors.training_date}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <label htmlFor="" className="form-label form_label">Training Duration (In Days)</label>
                <input type="number" className="form_input form-control" placeholder="Duration (In Days)"
                  name='duration' value={values.duration || ''} onChange={handleChange} onBlur={handleBlur}
                />
                {errors.duration && touched.duration ? (<span className='text-danger form_label' > {errors.duration}</span>) : null}
              </div>

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="UploadFile" className="form-label form_label file">Training Certificate</label>
                  <input type="file" className="form_input form-control" id="UploadFile" placeholder="Upload file"
                    name='ceritificate'
                    onChange={(e) => uploads(e.currentTarget.files[0], 'certificate')}
                    onBlur={handleBlur}
                  />
                  {errors.ceritificate && touched.ceritificate ? (<span className='text-danger form_label' > {errors.ceritificate}</span>) : null}
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className="mb-3">
                  <label htmlFor="OtherDoc" className="form-label form_label file">Other Document</label>
                  <input type="file" className="form_input form-control" id="OtherDoc" placeholder="Upload file"
                    name='other'
                    onChange={(e) => uploads(e.currentTarget.files[0], 'other')}
                    onBlur={handleBlur}
                  />
                  {errors.other && touched.other ? (<span className='text-danger form_label' > {errors.other}</span>) : null}
                </div>
              </div>

              <div className='text-end mt-4'>
                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>
                  Submit
                  {spinner ?
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className='ms-2'
                    />
                    : ''
                  }
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>

      <ToastContainer />
    </>
  )
}
